import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Provider} from "react-redux";
import store from "./store/store";
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import SignIn from "./pages/loginPage";
import './i18n';
import Documents from "./pages/documents";
import Reports from "./pages/reports";
import ReportAdd from "./pages/reportAdd";
import EditReport from "./pages/editReport";
import ViewReport from "./pages/viewReport";
import DocumentAdd from "./pages/documentAdd";
import EditDocument from "./pages/editDocument";
import Main from "./pages/main";
import Regions from "./pages/regions";
import UnderBranches from "./pages/underBranches";
import AllBranches from "./pages/allBranches";
import Personal from "./pages/personal";
import ProblemAdd from "./pages/problemAdd";
import EditProblem from "./pages/editProblem";
import ViewProblem from "./pages/viewProblem";
import Problems from "./pages/problems";
import Workers from "./pages/workers";
import WorkerAdd from "./pages/workerAdd";
import EditWorker from "./pages/editWorker";
import Sections from "./pages/sections";
import SectionAdd from "./pages/sectionAdd";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Suspense fallback={'Loading...'}>
            <Provider store={store}>
                <Routes>
                    <Route path={'/'} element={<App/>}/>
                    <Route path={'/dashboard/'} element={<App/>}/>
                    <Route path={'/login/'} element={<SignIn/>}/>

                    {/* Hujjatlar */}
                    <Route path={'/documents/'} element={<Documents/>}/>
                    <Route path={'/documents/:id'} element={<Documents/>}/>
                    <Route path={'/add-document/'} element={<DocumentAdd/>}/>
                    <Route path={'/edit-document/:id'} element={<EditDocument/>}/>

                    {/* Hisobotlar */}
                    <Route path={'/reports/'} element={<Reports/>}/>
                    <Route path={'/reports/:id'} element={<Reports/>}/>
                    <Route path={'/add-report/'} element={<ReportAdd/>}/>
                    <Route path={'/edit-report/:id'} element={<EditReport/>}/>
                    <Route path={'/view-report/:id'} element={<ViewReport/>}/>

                    {/* Muammolar */}
                    <Route path={'/problems/'} element={<Problems/>}/>
                    <Route path={'/problems/:id'} element={<Problems/>}/>
                    <Route path={'/add-problem/'} element={<ProblemAdd/>}/>
                    <Route path={'/edit-problem/:id'} element={<EditProblem/>}/>
                    <Route path={'/view-problem/:id'} element={<ViewProblem/>}/>

                    {/* Ishchilar */}
                    <Route path={'/workers/'} element={<Workers/>}/>
                    <Route path={'/workers/:id'} element={<Workers/>}/>
                    <Route path={'/add-worker/'} element={<WorkerAdd/>}/>
                    <Route path={'/edit-worker/:id'} element={<EditWorker/>}/>

                    {/* Admin navigatsiya */}
                    <Route path={'/main/'} element={<Main/>}/>
                    {/* Admin: Viloyatlar ro'yxati */}
                    <Route path={'/regions/'} element={<Regions/>}/>
                    {/* Admin: Viloyat kontekstida (ma'lumotlar + tashkilotlar) */}
                    <Route path={'/regions/:id'} element={<Main/>}/>
                    {/* Admin/Viloyat: Tashkilot kontekstida barcha bo'limlar */}
                    <Route path={'/regions/branch/:id'} element={<Main/>}/>
                    {/* Admin: Barcha tashkilotlar */}
                    <Route path={'/all-branches/'} element={<AllBranches/>}/>

                    {/* Viloyat navigatsiya */}
                    {/* Viloyat shaxsiy bo'limi */}
                    <Route path={'/personal/'} element={<Personal/>}/>
                    {/* Viloyatga tegishli tashkilotlar (viloyatId bilan yoki yo'q) */}
                    <Route path={'/branches/'} element={<UnderBranches/>}/>
                    <Route path={'/branches/:viloyatId'} element={<UnderBranches/>}/>

                    {/* Yangi bo'limlar */}
                    <Route path={'/sections/:sectionType/'} element={<Sections/>}/>
                    <Route path={'/sections/:sectionType/:id'} element={<Sections/>}/>
                    <Route path={'/add-section/:sectionType/'} element={<SectionAdd/>}/>
                </Routes>
            </Provider>
        </Suspense>
    </BrowserRouter>
);

reportWebVitals();